import { Action } from '@ngrx/store';
import {Module} from '../../my-features/module/module.model';
import * as actions from '../actions';
import { EntityState, EntityAdapter, createEntityAdapter } from '@ngrx/entity';


export interface UserModuleState extends EntityState<Module> {
  Loaded: boolean;
  Loading: boolean;
}

export const adapter: EntityAdapter<Module> = createEntityAdapter<Module>({
  selectId: model => model.Module
});

export const initialState: UserModuleState = adapter.getInitialState({
  Loaded: false,
  Loading: false,
});

export function reducer(state = initialState, action: actions.UserModuleActions): UserModuleState {
  switch (action.type) {
    case actions.UserModuleActionTypes.GetUserModlues:
      return {...state, Loaded: false, Loading: true};
    case  actions.UserModuleActionTypes.LoadUserModules:
      return adapter.setAll(action.payload, {...state, Loaded: true, Loading: false});

    default:
      return state;
  }
}

export const {
  selectIds,
  selectEntities,
  selectAll,
  selectTotal,
} = adapter.getSelectors();
